import React, { useState } from 'react';
import './Streetmap.css';
import { MapContainer, TileLayer, Marker, Popup, useMap, Circle, Polyline, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';

export function MapExperiment({ myApiClient }) {
    const [position, setPosition] = useState([51.051, 13.80641]);
    const [pop, setPop] = useState("vci Dresden");
    const [radius, setRadius] = useState(0);
    const [strecke, setStrecke] = useState([]);
    const [umkreis, setUmkreis] = useState(false);

    const newPosition = (newPos, newPop) => {
        setPosition(newPos);
        setPop(newPop);
    }

    return (
        <div style={{marginLeft: "3em"}}>
            <div style={{display: "flex"}}>
                <div>
                    <h3>Experimentieren mit Karte</h3>
                    <MapContainer center={[51.051, 13.80641]} zoom={13} scrollWheelZoom={true} style={{ height: "500px", width: "1000px"}}>
                        <TileLayer
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                        <BahnhofZeigen position={position} pop={pop} radius={radius}/>
                        {strecke.length>1 && <StreckeZeigen strecke={strecke} />}
                        <BahnhofUmkreise strecke={strecke} umkreis={umkreis}/>
                    </MapContainer>
                </div>
                <Legende newPosition={newPosition} newRadius={setRadius} setStrecke={setStrecke} setUmkreise={setUmkreis} umkreise={umkreis}/>
            </div>

            <Extras />
        </div>
    );
}

function BahnhofUmkreise({strecke, umkreis}) {
    if (strecke.length > 0 && umkreis) {
        return (
            strecke.map(bhf => <Circle center={bhf} pathOptions={{ fillColor: 'orange', color: "orange" }} radius={600} metric={true} />)
        )
    } else {
        return null
    }
}
function StreckeZeigen({ strecke }) {
    const map = useMap();
    if (strecke.length > 10) {
        map.setView([51.00122, 13.83002], 11)
    } else if (strecke.length > 1) {
        map.setView([50.98422, 13.59325], 11)}
    // } else {
    //     map.setView([51.051, 13.80641], 13)
    // }
    return (
        <>
        <Polyline pathOptions={{color: "red"}} positions={strecke} weight={11}>
            <Tooltip permanent offset={L.point([51.01531, 13.8362])}>Ich bin ein Pfad</Tooltip>
            {console.log('abstand:', L.point([51.01531, 13.8362]).distanceTo(L.point([51.06688, 13.74273])))}
            {console.log('abstand:', L.point([51.01531, 13.8362]).distanceTo(L.point([50.96374, 13.92967])))}
        </Polyline>
        </>
    )

}


function BahnhofZeigen({position, pop, radius}) {
    const map = useMap();
    if (radius > 0) {
        return (
            <Circle center={position} pathOptions={{ fillColor: 'purple', color: "purple" }} radius={radius} metric={true} />
        )
    } else if (position) {
        map.setView(position, 13);
        const markerIconConst = L.icon({
            iconUrl: markerIcon,
            iconRetinaUrl: markerIcon,
            iconAnchor: [5, 55],
            popupAnchor: [10, -44],
            iconSize: [24, 41],
          });
      
        return (
          <Marker icon={markerIconConst} position={position}>
            <Popup>Bahnhof: {pop}</Popup>
          </Marker>
        )
    } else {
        return null
    }
}
function Legende ({ newPosition, newRadius, setStrecke, umkreise, setUmkreise }) {
    const bhfs = [
        {
            id: 1,
            name: "Heidenau",
            xkoord: 13.8579,
            ykoord: 50.98201,
        },
        {
            id: 2,
            name: "Heidenau Großsedlitz",
            xkoord: 13.89455,
            ykoord: 50.96109,
        },
        {
            id: 3,
            name: "Heidenau Süd",
            xkoord: 13.8745,
            ykoord: 50.97225,
        }
    ];

    const [checkBhfs, setCheckBhfs] = useState({1: false, 2: false, 3: false})
    const [checkStrecke, setCheckStrecke] = useState({freiberg: false, pirna: false})

    const chooseBhf = event => {
        if (event.target.checked) {
            Object.keys(checkBhfs).map(bhf => setCheckBhfs(pre => ({...pre, [bhf]: false})));
            setCheckBhfs(pre => ({...pre, [event.target.id]: event.target.checked}));
            const [target] = bhfs.filter(bhf => bhf.id === parseInt(event.target.id));
            newPosition(L.latLng(target.ykoord, target.xkoord), target.name);
        } else {
            newRadius(0);
            setCheckBhfs(pre => ({...pre, [event.target.id]: event.target.checked}));
            newPosition([51.051, 13.80641], "vci Dresden");
        }
    }
    const chooseStrecke = event => {
        setCheckStrecke({freiberg: false, pirna: false});
        if (event.target.checked) {
            newPosition();
            setCheckStrecke(pre => ({...pre, [event.target.id]: event.target.checked}))
            setStrecke(strecken[event.target.id].map(bhf => L.latLng(bhf.ykoord, bhf.xkoord)))

        } else {
            setStrecke([]);
            newPosition([51.051, 13.80641], "vci Dresden");
        }
    }

    const showUmkreise = event => {
        setUmkreise(event.target.checked);
    }
    return (
        <div style={{marginLeft: "2em", marginTop: "3em"}}>
            <h4>Bahnhof anzeigen:</h4>
            <ul type="none">
                {bhfs.map(bhf => <li key={bhf.id}><input type="checkbox" id={bhf.id} checked={checkBhfs[bhf.id]} onChange={chooseBhf}/>{bhf.name}</li>)}
            </ul>
            {Object.values(checkBhfs).filter(state => state).length > 0 && <label>Radius (in m)<input type="number" placeholder="Umkreis" min="0" max="1000" step="50" onChange={e => newRadius(e.target.value)} style={{marginLeft: "1em"}}/></label>}
        
            <h4>Strecke anzeigen:</h4>
            <ul type="none">
                <li><input type="checkbox" id="freiberg" checked={checkStrecke.freiberg} onChange={chooseStrecke}/>Dresden - Freiberg</li>
                <li><input type="checkbox" id="pirna" checked={checkStrecke.pirna} onChange={chooseStrecke}/>Dresden - Pirna</li>
            </ul>
            {Object.values(checkStrecke).filter(s => s).length > 0 && <label style={{marginLeft: "2.5em"}}><input type="checkbox" checked={umkreise} onChange={showUmkreise}/>Bahnhöfe anzeigen</label>}
        </div>
    )
}
function Extras () {

    return (
        <div>
            <h4>Varianten</h4>
            <ol> 
                <li>Bahnhof auswählen und auf Karte angezeigt bekommen</li>
                <li>Umkreis mit variablem Radius um Bahnhof einzeichnen können </li>
                <li>Mehrere Bahnhöfe verbinden können</li>
                <li>Mehrere Bahnhöfe verbinden können. richtungsbezogen (mit Pfeilen?)</li>
                <li>Bahnhöfe verbinden mit Wichtung der einzelnen Strecken</li>

            </ol>

        </div>
    )
}

const strecken = {
    freiberg: [
        {
            pos: 1,
            bhf: 'Dresden Hbf',
            xkoord: 13.73216,
            ykoord: 51.04248
        },
        {
            pos: 2,
            bhf: 'Dresden-Plauen',
            xkoord: 13.70544,
            ykoord: 51.03134
        },
        {
            pos: 3,
            bhf: 'Freital-Potschappel',
            xkoord: 13.66335,
            ykoord: 51.01458
        },
        {
            pos: 4,
            bhf: 'Tharandt',
            xkoord: 13.59325,
            ykoord: 50.98422
        },
        {
            pos: 5,
            bhf: 'Klingenberg-Colmnitz',
            xkoord: 13.50334,
            ykoord: 50.92841
        },
        {
            pos: 6,
            bhf: 'Freiberg (Sachs)',
            xkoord: 13.34389,
            ykoord: 50.91068
        }
    ],
    pirna: [
        {
            pos: 1,
            bhf: 'Dresden Neustadt',
            xkoord: 13.74273,
            ykoord: 51.06688
        },
        {
            pos: 2,
            bhf: 'Dresden Mitte',
            xkoord: 13.72565,
            ykoord: 51.05703
        },
        {
            pos: 3,
            bhf: 'Dresden Freiberger Straße',
            xkoord: 13.71990,
            ykoord: 51.04880
        },
        {
            pos: 4,
            bhf: 'Dresden Hbf',
            xkoord: 13.73216,
            ykoord: 51.04248
        },
        {
            pos: 5,
            bhf: 'Dresden Strehlen',
            xkoord: 13.76335,
            ykoord: 51.03188
        },
        {
            pos: 6,
            bhf: 'Dresden Reick',
            xkoord: 13.79499,
            ykoord: 51.02176
        },
        {
            pos: 7,
            bhf: 'Dresden Dobritz',
            xkoord: 13.81023,
            ykoord: 51.01317
        },
        {
            pos: 8,
            bhf: 'Dresden Niedersedlitz',
            xkoord: 13.83002,
            ykoord: 51.00122
        },
        {
            pos: 9,
            bhf: 'Dresden Zschachwitz',
            xkoord: 13.84635,
            ykoord: 50.99113
        },
        {
            pos: 10,
            bhf: 'Heidenau',
            xkoord: 13.86100,
            ykoord: 50.98223
        },
        {
            pos: 11,
            bhf: 'Heidenau Süd',
            xkoord: 13.87594,
            ykoord: 50.97370
        },
        {
            pos: 12,
            bhf: 'Heidenau Großsedlitz',
            xkoord: 13.88664,
            ykoord: 50.96774
        },
        {
            pos: 13,
            bhf: 'Pirna',
            xkoord: 13.92967,
            ykoord: 50.96374
        }
    ]
}